import React, { FC, useEffect, useState, CSSProperties } from "react";
import { Fa } from "composants/Icon";
import { getEnvironment } from "api/userSettings";

function useEnvironment() {
  const [environment, setEnvironment] = useState<string | null>(null);

  useEffect(() => {
    getEnvironment()
      .then(response => setEnvironment(response.data.length > 0 ? response.data : null))
      .catch(e => {
        console.error("error fetch environment", e);
      });
  }, []);

  return environment;
}

// le texte est répété MARQUEE_REPEAT fois et la piste glisse d'une copie (100% / MARQUEE_REPEAT)
// pour une boucle sans saut : garder en phase avec le translateX de @keyframes environment-marquee
const MARQUEE_REPEAT = 5;

/**
 * Badge indiquant l'environnement (recette, préprod...), affiché à droite des onglets de galaxie,
 * le nom défilant en boucle (effet "Tickertape").
 */
export const EnvironmentBadge: FC<{ style?: CSSProperties }> = props => {
  const environment = useEnvironment();

  if (environment == null) {
    return null;
  }

  return (
    <span className="environment-badge" title={environment} style={props.style}>
      <Fa icon={["fal", "database"]} fixedWidth />
      <span className="environment-badge-window">
        <span className="environment-badge-track" aria-hidden="true">
          {`${environment} ✦ `.repeat(MARQUEE_REPEAT)}
        </span>
        <span className="is-sr-only">{environment}</span>
      </span>
    </span>
  );
};

const Ribbon: FC<{ style?: CSSProperties }> = props => {
  const environment = useEnvironment();

  if (environment != null) {
    return (
      <div className="ribbon" style={props.style}>
        <span className="icon">
          <Fa icon={["fal", "database"]} fixedWidth />
        </span>
        <span>{environment}</span>
      </div>
    );
  } else {
    return <div />;
  }
};
export default Ribbon;
